import { Controller } from "@hotwired/stimulus"

// Gère le comportement du banner d'alertes client
// - Permet de fermer temporairement le banner
// - Le banner réapparaît si le client a des alertes actives

export default class extends Controller {
  static values = { clientId: Number }

  dismiss() {
    // Masquer le banner temporairement (pour cette session)
    this.element.classList.add("hidden")
    
    // Optionnel: stocker en sessionStorage pour éviter réaffichage
    if (this.clientIdValue) {
      const key = `client_alert_dismissed_${this.clientIdValue}`
      sessionStorage.setItem(key, Date.now().toString())
    }
  }

  connect() {
    // Vérifier si le banner a été fermé récemment (dans les 5 dernières minutes)
    if (this.clientIdValue) {
      const key = `client_alert_dismissed_${this.clientIdValue}`
      const dismissedAt = sessionStorage.getItem(key)
      
      if (dismissedAt) {
        const fiveMinutesAgo = Date.now() - (5 * 60 * 1000)
        if (parseInt(dismissedAt) > fiveMinutesAgo) {
          this.element.classList.add("hidden")
        } else {
          // Expiration, on nettoie
          sessionStorage.removeItem(key)
        }
      }
    }
  }
}
